// Mock data for Ssuq B2B marketplace (Algeria) — MOCKED DATA (frontend only)
// TVA Algérie = 19%
export const TVA = 0.19;

export const CATEGORIES = [
  {
    id: "laitier",
    name: { fr: "Produits laitiers", ar: "منتجات الألبان" },
    short: { fr: "Laitier", ar: "الألبان" },
    desc: { fr: "Lait, yaourts, fromages, beurre et crèmes.", ar: "حليب، ياغورت، أجبان، زبدة وكريمات." },
    image: "/categories/laitier.jpg"
  },
  {
    id: "boissons",
    name: { fr: "Boissons", ar: "المشروبات" },
    short: { fr: "Boissons", ar: "مشروبات" },
    desc: { fr: "Sodas, jus, eaux minérales — par palette ou par pack.", ar: "مشروبات غازية، عصائر، مياه معدنية — بالطبلية أو الحزمة." },
    image: "https://images.unsplash.com/photo-1625865019845-7b2c89b8a8a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "conserves",
    name: { fr: "Conserves", ar: "المعلبات" },
    short: { fr: "Conserves", ar: "معلبات" },
    desc: { fr: "Thon, tomate, légumes et fruits en conserve.", ar: "تونة، طماطم، خضر وفواكه معلبة." },
    image: "/categories/conserves.jpg"
  },
  {
    id: "pates",
    name: { fr: "Pâtes & Semoules", ar: "العجائن والسميد" },
    short: { fr: "Pâtes", ar: "عجائن" },
    desc: { fr: "Pâtes, semoule, couscous et riz.", ar: "عجائن، سميد، كسكس وأرز." },
    image: "https://images.unsplash.com/photo-1612966893103-790e549a2ab1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "sucre",
    name: { fr: "Sucre & Confiserie", ar: "السكر والحلويات" },
    short: { fr: "Sucre", ar: "سكر" },
    desc: { fr: "Sucre, bonbons, chocolats et confiseries.", ar: "سكر، حلوى، شوكولاطة وحلويات." },
    image: "/categories/sucre.jpg"
  },
  {
    id: "huiles",
    name: { fr: "Huiles & Condiments", ar: "الزيوت والتوابل" },
    short: { fr: "Huiles", ar: "زيوت" },
    desc: { fr: "Huiles, vinaigres, sauces et épices.", ar: "زيوت، خل، صلصات وتوابل." },
    image: "/categories/huiles.jpg"
  },
  {
    id: "epicerie",
    name: { fr: "Épicerie sèche", ar: "البقالة الجافة" },
    short: { fr: "Épicerie", ar: "بقالة" },
    desc: { fr: "Café, thé, légumes secs et produits secs.", ar: "قهوة، شاي، بقول ومواد جافة." },
    image: "https://images.unsplash.com/photo-1754294437681-4ec491072dfc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "patisserie",
    name: { fr: "Pâtisserie & Ingrédients", ar: "الحلويات والمكونات" },
    short: { fr: "Pâtisserie", ar: "حلويات" },
    desc: { fr: "Farines, levures et ingrédients pour boulangers.", ar: "دقيق، خمائر ومكونات للمخابز." },
    image: "/categories/patisserie.jpg"
  },
  {
    id: "surgeles",
    name: { fr: "Surgelés", ar: "المجمدات" },
    short: { fr: "Surgelés", ar: "مجمدات" },
    desc: { fr: "Frites, panés, légumes et pâtes surgelées à -18 °C.", ar: "بطاطا، مقرمشات، خضر وعجائن مجمدة عند -18°." },
    image: "https://images.unsplash.com/photo-1597362925123-77861d3fbac7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "frais",
    name: { fr: "Produits frais", ar: "المنتجات الطازجة" },
    short: { fr: "Frais", ar: "طازج" },
    desc: { fr: "Viandes, volailles, fromages et charcuterie.", ar: "لحوم، دواجن، أجبان وأطعمة باردة." },
    image: "https://images.unsplash.com/photo-1689774504345-6cf299b0b312?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "cosmetique",
    name: { fr: "Cosmétique & Beauté", ar: "التجميل والعناية" },
    short: { fr: "Cosmétique", ar: "تجميل" },
    desc: { fr: "Soins, maquillage, parfums et beauté.", ar: "عناية، مكياج، عطور وجمال." },
    image: "/categories/cosmetique.jpg"
  },
  {
    id: "hygiene",
    name: { fr: "Hygiène & Entretien", ar: "النظافة والصيانة" },
    short: { fr: "Hygiène", ar: "نظافة" },
    desc: { fr: "Détergents, savons, papier et produits d'entretien.", ar: "منظفات، صابون، ورق ومنتجات صيانة." },
    image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  }
];

export const PRODUCTS = [
  {
    id: "semoule-sim-25",
    name: { fr: "Semoule supérieure de blé dur — 25 kg", ar: "سميد ممتاز من القمح الصلب — 25 كغ" },
    vendor: "SIM — Semoulerie Industrielle",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "epicerie",
    desc: { fr: "Semoule extra de blé dur, idéale couscous et pâtisserie. Sac 25 kg.", ar: "سميد ممتاز من القمح الصلب، مثالي للكسكس والحلويات. كيس 25 كغ." },
    unit: { fr: "sac 25 kg", ar: "كيس 25 كغ" },
    priceHT: 4200,
    moq: 4,
    image: "https://images.unsplash.com/photo-1714842981153-ffeaf74e7a1a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "hamoud-assort-1l",
    name: { fr: "Boissons gazeuses assorties 1 L — pack x6", ar: "مشروبات غازية متنوعة 1 ل — حزمة × 6" },
    vendor: "Hamoud Boualem",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "boissons",
    desc: { fr: "Assortiment Hamoud, Selecto, Hamoud Cola et Slim, bouteilles 1 L. Pack de 6.", ar: "تشكيلة حمود، سيلكتو، حمود كولا وسليم، قوارير 1 ل. حزمة من 6." },
    unit: { fr: "pack x6", ar: "حزمة × 6" },
    priceHT: 560,
    moq: 10,
    image: "/brands/hamoud.jpg"
  },
  {
    id: "bimo-maliya",
    name: { fr: "Biscuits Bimo Maliya Cin d'Or — présentoir x24", ar: "بسكويت بيمو مالية سين دور — علبة × 24" },
    vendor: "Bimo",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "epicerie",
    desc: { fr: "Biscuits sablés fourrés Maliya, format familial. Présentoir de 24.", ar: "بسكويت مالية محشو، حجم عائلي. علبة من 24." },
    unit: { fr: "présentoir x24", ar: "علبة × 24" },
    priceHT: 1320,
    moq: 2,
    image: "/brands/bimo.jpg"
  },
  {
    id: "awane-serviettes",
    name: { fr: "Serviettes hygiéniques Awane Ultra — colis x24", ar: "فوط صحية أوان ألترا — حزمة × 24" },
    vendor: "Awane",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "hygiene",
    desc: { fr: "Serviettes hygiéniques ultra-fines, paquet de 8. Colis de 24 paquets.", ar: "فوط صحية رقيقة جداً، عبوة من 8. حزمة من 24 عبوة." },
    unit: { fr: "colis x24", ar: "حزمة × 24" },
    priceHT: 2280,
    moq: 1,
    image: "/brands/awane.jpg"
  },
  {
    id: "danone-yomi",
    name: { fr: "Yaourt Danone Yomi assorti — pack x24", ar: "زبادي دانون يومي متنوع — حزمة × 24" },
    vendor: "Danone Djurdjura Algérie",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "frais",
    desc: { fr: "Yaourts brassés vanille et fruits, pots 100 g. Pack de 24 — chaîne du froid.", ar: "زبادي بالفانيليا والفواكه، عبوات 100 غ. حزمة من 24 — سلسلة تبريد." },
    unit: { fr: "pack x24", ar: "حزمة × 24" },
    priceHT: 720,
    moq: 4,
    image: "/brands/danone.jpg"
  },
  {
    id: "riz-25",
    name: { fr: "Riz long grain — sac 25 kg", ar: "أرز حبة طويلة — كيس 25 كغ" },
    vendor: "Négoce Import Alger",
    vendorType: { fr: "Importateur", ar: "مستورد" },
    category: "epicerie",
    desc: { fr: "Riz long grain de qualité import, grain régulier. Sac 25 kg.", ar: "أرز حبة طويلة مستورد، حبة منتظمة. كيس 25 كغ." },
    unit: { fr: "sac 25 kg", ar: "كيس 25 كغ" },
    priceHT: 9800,
    moq: 2,
    image: "https://images.unsplash.com/photo-1465176728568-7da7e336b1e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "huile-5l",
    name: { fr: "Huile de table 5 L — carton x4", ar: "زيت المائدة 5 ل — كرتون × 4" },
    vendor: "Cevital",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "epicerie",
    desc: { fr: "Huile végétale raffinée, bidon 5 L. Carton de 4 bidons.", ar: "زيت نباتي مكرر، عبوة 5 ل. كرتون من 4 عبوات." },
    unit: { fr: "carton x4", ar: "كرتون × 4" },
    priceHT: 3600,
    moq: 2,
    image: "https://images.unsplash.com/photo-1574785289548-b6604d39125d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "soda-selecto",
    name: { fr: "Soda Selecto 1 L — pack x6", ar: "مشروب سيلكتو 1 ل — حزمة × 6" },
    vendor: "Hamoud Boualem",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "boissons",
    desc: { fr: "Le soda culte en bouteille 1 L. Pack de 6.", ar: "المشروب الأسطوري في قارورة 1 ل. حزمة من 6." },
    unit: { fr: "pack x6", ar: "حزمة × 6" },
    priceHT: 540,
    moq: 10,
    image: "https://images.unsplash.com/photo-1625865019554-220ea80ea813?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "eau-ifri",
    name: { fr: "Eau minérale 1,5 L — pack x6", ar: "مياه معدنية 1.5 ل — حزمة × 6" },
    vendor: "Ifri",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "boissons",
    desc: { fr: "Eau minérale naturelle 1,5 L. Pack de 6 bouteilles.", ar: "مياه معدنية طبيعية 1.5 ل. حزمة من 6 قوارير." },
    unit: { fr: "pack x6", ar: "حزمة × 6" },
    priceHT: 210,
    moq: 20,
    image: "https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "jus-rouiba",
    name: { fr: "Jus d'orange 1 L — pack x6", ar: "عصير برتقال 1 ل — حزمة × 6" },
    vendor: "NCA Rouiba",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "boissons",
    desc: { fr: "Jus de fruits 1 L, brique. Pack de 6.", ar: "عصير فواكه 1 ل، علبة. حزمة من 6." },
    unit: { fr: "pack x6", ar: "حزمة × 6" },
    priceHT: 720,
    moq: 8,
    image: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "cafe-1kg",
    name: { fr: "Café moulu 1 kg — carton x10", ar: "قهوة مطحونة 1 كغ — كرتون × 10" },
    vendor: "Négoce Import Alger",
    vendorType: { fr: "Importateur", ar: "مستورد" },
    category: "epicerie",
    desc: { fr: "Café torréfié moulu, paquet 1 kg. Carton de 10.", ar: "قهوة محمصة مطحونة، علبة 1 كغ. كرتون من 10." },
    unit: { fr: "carton x10", ar: "كرتون × 10" },
    priceHT: 11500,
    moq: 1,
    image: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "tomate-benamor",
    name: { fr: "Double concentré de tomate 800 g — carton x12", ar: "مركز طماطم مضاعف 800 غ — كرتون × 12" },
    vendor: "Conserverie Amor Benamor",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "epicerie",
    desc: { fr: "Double concentré de tomate 28%, boîte 800 g. Carton de 12.", ar: "مركز طماطم مضاعف 28%، علبة 800 غ. كرتون من 12." },
    unit: { fr: "carton x12", ar: "كرتون × 12" },
    priceHT: 3900,
    moq: 2,
    image: "https://images.unsplash.com/photo-1626607007733-d09228471d9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "dattes-deglet",
    name: { fr: "Dattes Deglet Nour — carton 5 kg", ar: "تمر دقلة نور — كرتون 5 كغ" },
    vendor: "Coopérative de Biskra",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "frais",
    desc: { fr: "Dattes Deglet Nour branchées, calibre export. Carton 5 kg.", ar: "تمر دقلة نور على العرجون، عيار التصدير. كرتون 5 كغ." },
    unit: { fr: "carton 5 kg", ar: "كرتون 5 كغ" },
    priceHT: 2800,
    moq: 2,
    image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "fromage-edam",
    name: { fr: "Fromage Edam — bloc 2,5 kg", ar: "جبن إيدام — قالب 2.5 كغ" },
    vendor: "Négoce Import Alger",
    vendorType: { fr: "Importateur", ar: "مستورد" },
    category: "frais",
    desc: { fr: "Fromage Edam en bloc, à trancher ou râper. 2,5 kg.", ar: "جبن إيدام قالب، للتقطيع أو البشر. 2.5 كغ." },
    unit: { fr: "bloc 2,5 kg", ar: "قالب 2.5 كغ" },
    priceHT: 2650,
    moq: 2,
    image: "https://images.unsplash.com/photo-1772910206934-0db24c87c4b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "frites-surgelees",
    name: { fr: "Frites surgelées 9x9 — sac 2,5 kg", ar: "بطاطا مقلية مجمدة 9×9 — كيس 2.5 كغ" },
    vendor: "Import Froid Négoce",
    vendorType: { fr: "Importateur", ar: "مستورد" },
    category: "surgeles",
    desc: { fr: "Frites précuites 9x9 mm, cuisson friteuse. Sac 2,5 kg.", ar: "بطاطا مسبقة الطهي 9×9 مم، للقلي. كيس 2.5 كغ." },
    unit: { fr: "sac 2,5 kg", ar: "كيس 2.5 كغ" },
    priceHT: 1150,
    moq: 6,
    image: "https://images.unsplash.com/photo-1651383140368-9b3ee59c2981?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "farine-boulangere",
    name: { fr: "Farine boulangère T55 — sac 25 kg", ar: "دقيق المخابز T55 — كيس 25 كغ" },
    vendor: "Moulins du Sahel",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "patisserie",
    desc: { fr: "Farine de blé tendre T55 pour pain et viennoiserie. Sac 25 kg.", ar: "دقيق القمح اللين T55 للخبز والمعجنات. كيس 25 كغ." },
    unit: { fr: "sac 25 kg", ar: "كيس 25 كغ" },
    priceHT: 2450,
    moq: 4,
    image: "https://images.unsplash.com/photo-1588467850695-a898367ce465?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "barquettes-alu",
    name: { fr: "Barquettes aluminium — carton 500", ar: "علب ألمنيوم — كرتون 500" },
    vendor: "Embal Pack Algérie",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "emballages",
    desc: { fr: "Barquettes aluminium 900 ml avec couvercles. Carton de 500.", ar: "علب ألمنيوم 900 مل مع أغطية. كرتون من 500." },
    unit: { fr: "carton 500", ar: "كرتون 500" },
    priceHT: 5200,
    moq: 1,
    image: "https://images.unsplash.com/photo-1616205255812-c07c8102cc02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "sacs-kraft",
    name: { fr: "Sacs kraft alimentaires — carton 1000", ar: "أكياس كرافت غذائية — كرتون 1000" },
    vendor: "Embal Pack Algérie",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "emballages",
    desc: { fr: "Sacs kraft brun pour vente à emporter. Carton de 1000.", ar: "أكياس كرافت بنية للبيع للاصطحاب. كرتون من 1000." },
    unit: { fr: "carton 1000", ar: "كرتون 1000" },
    priceHT: 3400,
    moq: 1,
    image: "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  }
  ,
  {
    id: "javel-5l",
    name: { fr: "Eau de Javel 5 L — carton x4", ar: "ماء جافيل 5 ل — كرتون × 4" },
    vendor: "Sanitol Algérie",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "hygiene",
    desc: { fr: "Eau de Javel concentrée, bidon 5 L. Carton de 4 bidons.", ar: "ماء جافيل مركّز، عبوة 5 ل. كرتون من 4 عبوات." },
    unit: { fr: "carton x4", ar: "كرتون × 4" },
    priceHT: 1800,
    moq: 2,
    image: "https://images.unsplash.com/photo-1649005011845-ef225c89da86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "vaisselle-5l",
    name: { fr: "Liquide vaisselle 5 L — bidon", ar: "سائل غسل الأواني 5 ل — عبوة" },
    vendor: "Henkel Algérie",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "hygiene",
    desc: { fr: "Détergent vaisselle concentré, dégraissant. Bidon 5 L.", ar: "منظف أواني مركّز، مزيل للدهون. عبوة 5 ل." },
    unit: { fr: "bidon 5 L", ar: "عبوة 5 ل" },
    priceHT: 950,
    moq: 4,
    image: "https://images.unsplash.com/photo-1647577746559-c9a28c0d0870?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "savon-mains-5l",
    name: { fr: "Savon liquide mains 5 L — bidon", ar: "صابون سائل لليدين 5 ل — عبوة" },
    vendor: "Hygiène Pro Négoce",
    vendorType: { fr: "Importateur", ar: "مستورد" },
    category: "hygiene",
    desc: { fr: "Savon liquide pour distributeurs, recharge 5 L.", ar: "صابون سائل للموزعات، تعبئة 5 ل." },
    unit: { fr: "bidon 5 L", ar: "عبوة 5 ل" },
    priceHT: 1250,
    moq: 2,
    image: "https://images.unsplash.com/photo-1590610994353-7b0e7546e681?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "essuie-tout",
    name: { fr: "Essuie-tout professionnel — colis x12", ar: "مناشف ورقية مهنية — حزمة × 12" },
    vendor: "Hygiène Pro Négoce",
    vendorType: { fr: "Importateur", ar: "مستورد" },
    category: "hygiene",
    desc: { fr: "Bobines d'essuie-tout ouate double épaisseur. Colis de 12.", ar: "لفائف ورقية مزدوجة السمك. حزمة من 12." },
    unit: { fr: "colis x12", ar: "حزمة × 12" },
    priceHT: 1400,
    moq: 2,
    image: "https://images.unsplash.com/photo-1550963295-019d8a8a61c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  },
  {
    id: "spray-nettoyant",
    name: { fr: "Spray nettoyant multi-surfaces — carton x12", ar: "بخاخ منظف متعدد الأسطح — كرتون × 12" },
    vendor: "Sanitol Algérie",
    vendorType: { fr: "Producteur", ar: "منتج" },
    category: "hygiene",
    desc: { fr: "Nettoyant désinfectant multi-surfaces 750 ml. Carton de 12.", ar: "منظف مطهر متعدد الأسطح 750 مل. كرتون من 12." },
    unit: { fr: "carton x12", ar: "كرتون × 12" },
    priceHT: 2600,
    moq: 1,
    image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
  }
];

export const SECTORS = [
  { id: "alim", fr: "Alimentation de proximité", ar: "محلات المواد الغذائية للقرب" },
  { id: "resto", fr: "Restaurants", ar: "المطاعم" },
  { id: "pizzeria", fr: "Pizzerias", ar: "محلات البيتزا" },
  { id: "fastfood", fr: "Fast-foods", ar: "الوجبات السريعة" },
  { id: "cosmetique", fr: "Magasins de cosmétique", ar: "متاجر مواد التجميل" }
];

// Correspondance activité (secteur) -> catégories pertinentes pour la sélection ciblée
export const SECTOR_CATEGORIES = {
  alim: ["laitier", "boissons", "conserves", "pates", "sucre", "huiles", "epicerie", "surgeles", "frais", "patisserie", "hygiene"],
  resto: ["laitier", "conserves", "huiles", "pates", "epicerie", "frais", "surgeles", "sucre", "patisserie"],
  pizzeria: ["laitier", "conserves", "huiles", "pates", "epicerie", "frais", "patisserie", "sucre"],
  fastfood: ["boissons", "huiles", "surgeles", "conserves", "epicerie", "sucre", "patisserie", "frais"],
  cosmetique: ["cosmetique", "hygiene"]
};

// Retrouve l'id de secteur à partir du libellé d'activité stocké (fr ou ar)
export const sectorIdFromActivity = (activity) => {
  if (!activity) return null;
  const s = SECTORS.find((x) => x.fr === activity || x.ar === activity);
  return s ? s.id : null;
};

export const WILAYAS = [
  "Alger", "Oran", "Constantine", "Annaba", "Blida", "Sétif", "Batna",
  "Tizi Ouzou", "Béjaïa", "Tlemcen", "Sidi Bel Abbès", "Djelfa", "Biskra"
];
